import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getLabel } from "../utils/labels";
import { userRoles } from "../../../constant";
import { SelectInput } from "../../../components/SelectInput/SelectInput";

export const VALID_CERTIFICATION_TYPES = [userRoles.Manager, userRoles.AccountSpecialist];

export function getInitialCertificationType(searchParams: URLSearchParams): string {
    const param = searchParams.get("certificationType");
    return param && VALID_CERTIFICATION_TYPES.includes(param) ? param : userRoles.Manager;
}

export const useCertificationTypeSelect = () => {
    const [searchParams] = useSearchParams();
    const [certificationType, setCertificationType] = useState<string>(
        () => getInitialCertificationType(searchParams)
    );
    return {
        certificationType,
        setCertificationType,
    };
};

const options = (labels: any) => [
    { label: `Team ${getLabel("certification.plural", labels)}`, value: userRoles.Manager },
    { label: `My ${getLabel("certification.plural", labels)}`, value: userRoles.AccountSpecialist },
]

export function CertificationTypeSelect({ labels, setCertificationType, certificationType }: { labels: any, setCertificationType: (type: string) => void, certificationType: string }) {
    const handleCertificationTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setCertificationType(e.target.value);
    }
    return (
        <div>
            <SelectInput
                options={options(labels)}
                value={certificationType || ""}
                onChange={handleCertificationTypeChange}
                placeholder={`Select type`}
                className="!py-2.5 !px-3 text-sm font-medium flex-[3] !border-none w-[200px]"
                containerClassName="flex-[3]"
            />
        </div>
    );
}